import React from 'react';
import styled from 'styled-components/macro';
import { Discount } from '../../../../types/discounts';
import Badges from './badges';
import Period from './period';
import Stamps from './stamps';
import Store from './store';

interface DiscountItemProps {
    discount: Discount;
    onClick: (discountId: string) => void;
}

const DiscountItem = (
    {
        discount,
        onClick,
    }: DiscountItemProps
) => {
    return (
        <Container onClick={() => {
            onClick(discount.id || '');
        }}>
            <Title>{discount.name || 'N/A'}</Title>
            <BadgesContainer>
                <Badges discount={discount} />
            </BadgesContainer>

            <Stamps discount={discount} />

            <TimeContainer>
                <Period discount={discount} />
            </TimeContainer>

            <Store discount={discount} />
        </Container>
    );
};

const Container = styled.a`
    padding: 18px 16px;
    border: 2px solid #f2f2f2;
    border-radius: 2px;
    cursor: pointer;
    display: block;
    
    & + & {
        margin-top: 16px;
    }
`;

const Title = styled.div`
    font-size: 23px;
    color: #495E61;
    font-weight: 700;
`;

const BadgesContainer = styled.div`
    display: flex;
    margin-top: 13px;
`;

const TimeContainer = styled.div`
    display: flex;
    margin-top: 21px;
`;

export default DiscountItem;

